import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import Routes from '~/routes';
import GlobalStyle from '~/styles/global';
import { defaultTheme } from '~/styles/Theme/styles';
import PageProvider from './context/PageContext';
import { store } from './store';

const App: React.FC = () => (
  <BrowserRouter>
    <Provider store={store}>
      <GlobalStyle />
      <PageProvider>
        <ThemeProvider theme={defaultTheme}>
          <Routes />
        </ThemeProvider>
      </PageProvider>
    </Provider>
  </BrowserRouter>
);

export default App;
